import { render, staticRenderFns } from "./invalid.vue?vue&type=template&id=19d04bb6&scoped=true&"
import script from "./invalid.vue?vue&type=script&lang=js&"
export * from "./invalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d04bb6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSelect,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d04bb6')) {
      api.createRecord('19d04bb6', component.options)
    } else {
      api.reload('19d04bb6', component.options)
    }
    module.hot.accept("./invalid.vue?vue&type=template&id=19d04bb6&scoped=true&", function () {
      api.rerender('19d04bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/invalid.vue"
export default component.exports